export default __webpack_public_path__ + "static/media/fav-icon.a882063e.png";